import {
  FORMAT,
  RESOURCE_TYPE_STAFFER,
  RESOURCE_TYPE_APPLIANCE,
  APPOINTMENT_STATUSES_MAP,
  BOOKING_TYPE_BUSINESS,
  BOOKING_TYPE_CUSTOMER,
  BOOKING_TYPE_RESERVATION,
  BOOKING_TYPE_TIMEOFF,
  BOOKING_TYPE_BREAK,
  PARTNER_APP_TYPES,
  PARTNER_APP_DATA_SYNC_STATUS,
} from '@/lib/consts.js'

import { shapeFromEvent } from '@/components/calendar/functions.js'

import moment from 'moment'

import Proxy from '@/lib/object-proxy.js'

export default Proxy({

  from () {
    return moment(this.booked_from, FORMAT)
  },

  till () {
    return moment(this.booked_till, FORMAT)
  },

  gapStart () {
    return this.gap_hole_start && moment(this.gap_hole_start, FORMAT)
  },

  gapEnd () {
    return this.gap_hole_end && moment(this.gap_hole_end, FORMAT)
  },

  shape () {
    return shapeFromEvent(this)
  },

  customerName () {
    if (this.customer && (this.customer.id || this.customer.name)) {
      return this.customer.name || ''
    }

    if (this.$meta && this.$meta.customer && (this.$meta.customer.id || this.$meta.customer.name)) {
      return this.$meta.customer.name || ''
    }

    return ''
  },

  isWalkin () {
    return !(this.customer && this.customer.id)
  },

  _status () {
    return this.status || (this.$meta && this.$meta.status)
  },

  _type () {
    return this.type || (this.$meta && this.$meta.type)
  },

  staffer () {
    if (!this.resources) return null
    return this.resources.find(r => r.type === RESOURCE_TYPE_STAFFER)
  },

  appliance () {
    if (!this.resources) return null
    return this.resources.find(r => r.type === RESOURCE_TYPE_APPLIANCE)
  },

  isBooking () {
    return this._type === BOOKING_TYPE_BUSINESS || this._type === BOOKING_TYPE_CUSTOMER
  },

  hasGapHole () {
    return this.isBooking && !!this.gapStart && !!this.gapEnd
  },

  isPaid () {
    return this.$meta ? this.$meta.paid : this.paid
  },

  isTimeoff () {
    return this._type === BOOKING_TYPE_TIMEOFF
  },

  isBreak () {
    return this._type === BOOKING_TYPE_BREAK
  },

  isNoShow () {
    return this._status === APPOINTMENT_STATUSES_MAP.NOSHOW
  },

  isCanceled () {
    return this._status === APPOINTMENT_STATUSES_MAP.CANCELED
  },

  isReservation () {
    return this._type === BOOKING_TYPE_RESERVATION
  },

  isNonworking () {
    return false
  },

  isBoost () {
    return this.from_promo || (this.$meta && this.$meta.from_promo)
  },

  needsConfirmation () {
    // modified or waiting
    return this._status === APPOINTMENT_STATUSES_MAP.MODIFIED
      || this._status === APPOINTMENT_STATUSES_MAP.UNCONFIRMED
  },

  isNew () {
    return this.$meta && this.$meta.new
  },

  isPhysioSyncPending () {
    return this.partner_app_data?.[PARTNER_APP_TYPES.PHYSIOREGISTRATION]?.['sync_status'] === PARTNER_APP_DATA_SYNC_STATUS.PENDING
  },

  isCurrentUser () {
    return !!this.resources?.find(e => e.is_current_user)
  },

})
